module.exports = "/_next/static/images/hero-girl-circle-6d8a566f41f1d749039c7760f9dd84db.png";